import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "worldOutlook-list-view"
};
const _hoisted_2 = {
  class: "world_outlook_header"
};
const _hoisted_3 = {
  class: "card-title"
};
const _hoisted_4 = {
  class: "card-sub-title"
};
const _hoisted_5 = {
  class: "world_outlook_operator"
};
const _hoisted_6 = {
  class: "wo-mode-container"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "content-indicator"
};
const _hoisted_9 = {
  class: "content-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElButton } from 'element-plus';
import store from '@/store';
import router from '@/router';
import { request } from '@/manager/net_manager';
import { inApostleType, isAdminType, isUserType } from '@/tools/utils';
import 'element-plus/es/components/statistic/style/css';
import WOOrganizationList from '@/components/WorldOutlook/WOOrganizationList.vue';
import WOApostleList from '@/components/WorldOutlook/WOApostleList.vue';
import WoQualifications from '@/components/WorldOutlook/WOQualifications.vue';
import WORoleList from '@/components/WorldOutlook/WORoleList.vue';
import WOEntryExplanations from '@/components/WorldOutlook/WOEntryExplanations.vue';
import WOPerformanceList from '@/components/WorldOutlook/WOPerformanceList.vue';
import WOSkills from '@/components/WorldOutlook/WOSkills.vue';
import WOQuarterRank from '@/components/WorldOutlook/WOQuarterRank.vue';
import WOMarketChannel from '@/components/WorldOutlook/WOMarketChannel.vue';
import WORolesWithOrganizations from '@/components/WorldOutlook/WORolesWithOrganizations.vue';
import WOItemCard from '@/components/WorldOutlook/WOItemCard.vue';
import WOMarketProps from '@/components/WorldOutlook/WOMarketProps.vue';
import WORoleProps from '@/components/WorldOutlook/WORoleProps.vue';
import WOFerryman from "@/components/WorldOutlook/WOFerryman.vue";
import WOCapabilityManager from "@/components/WorldOutlook/WOCapabilityManager.vue";
import { pageStyle } from "@/theme/sliderStyle";
export default {
  __name: 'WorldOutlookPage',

  setup(__props) {
    const baseItemArray = [{
      'title': '世界观组织',
      'desc': '该世界观内，与选中者密切相关的主要组织',
      'image': require('@/assets/icon/wo_organizations.png'),
      'key': 'organizations'
    }, {
      'title': '登记剧本',
      'desc': '世界观目前登记的剧本',
      'image': require('@/assets/icon/wo_dramas.png'),
      'key': 'dramas'
    }, {
      'title': '历史演出',
      'desc': '使用该世界观剧本完成谢幕的演出',
      'image': require('@/assets/icon/wo_performances.png'),
      'key': 'performances'
    }, {
      'title': '词条释义',
      'desc': '该世界观下的设定及名词解释',
      'image': require('@/assets/icon/wo_entries.png'),
      'key': 'entries'
    }, {
      'title': '链接者',
      'desc': '获得许可创建、引导该世界观链接的链接者',
      'image': require('@/assets/icon/wo_apostles.png'),
      'key': 'apostles'
    }, {
      'title': '雾海舟子',
      'desc': '在雾海工作，与链接者配合构建跨世界链接的舟子',
      'image': require('@/assets/icon/wo_ferryman.png'),
      'key': 'ferryman'
    }, {
      'title': '',
      'desc': '',
      'key': ''
    }, {
      'title': `季度排行 / ${new Date().getFullYear()}`,
      'desc': '世界观下的选中者于当前季度的活跃排行',
      'image': require('@/assets/icon/wo_quarter.png'),
      'key': 'quarter'
    }];
    const apostleItemArray = [{
      'title': '资格管理',
      'desc': '与该世界观产生联系的资格纽带，及相关角色管理',
      'image': require('@/assets/icon/wo_qualifications.png'),
      'key': 'qualifications'
    }, {
      'title': '市场渠道管理',
      'desc': '该世界观下提供给海市的销售渠道，及相关商品管理',
      'image': require('@/assets/icon/wo_market_channels.png'),
      'key': 'marketChannels'
    }, {
      'title': '角色道具统计',
      'desc': '该世界观下角色所持有的所有道具，及道具信息管理',
      'image': require('@/assets/icon/wo_pocket_props.png'),
      'key': 'roleProps'
    }, {
      'title': '市场道具统计',
      'desc': '该世界观下所有市场道具，及道具信息管理',
      'image': require('@/assets/icon/wo_market_props.png'),
      'key': 'marketProps'
    }, {
      'title': '技能树',
      'desc': '该世界观中设定的特有技能',
      'image': require('@/assets/icon/wo_skills.png'),
      'key': 'skills'
    }, {
      'title': '选中者',
      'desc': '在当前世界观下被选中的角色',
      'image': require('@/assets/icon/wo_roles.png'),
      'key': 'roles'
    }, {
      'title': '角色组织关系管理',
      'desc': '世界观角色与世界观组织的关系管理',
      'image': require('@/assets/icon/wo_ro_relations.png'),
      'key': 'rolesWithOrganizations'
    }, {
      'title': '能力配置管理',
      'desc': '世界观所使用的能力配置',
      'image': require('@/assets/icon/wo_capabilities.png'),
      'key': 'capabilityManager'
    }]; // refs

    const woArray = ref([]);
    const mode = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const modeArray = computed(() => {
      if (inApostleType(userType.value)) {
        return [...baseItemArray, ...apostleItemArray];
      } else {
        return baseItemArray;
      }
    });
    const dataArray = computed(() => {
      if (worldOutlook.value === null) return woArray.value;
      const buffer = woArray.value.filter(item => item.id === worldOutlook.value.id);
      if (buffer.length === 0) return null;
      return [buffer[0]];
    });
    const selectedModeData = computed(() => {
      if (mode.value === null) return null;
      const buffer = modeArray.value.filter(item => item.key === mode.value);
      if (buffer.length === 0) return null;
      return buffer[0];
    }); // functions

    const getData = () => {
      request('world_outlook/get_world_outlook_list/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          woArray.value = response.data;
        }
      });
    };

    const handleClick = (worldOutlook, target) => {
      if (!worldOutlook.value || worldOutlook.value.id !== worldOutlook.id) {
        store.commit('update_world_outlook', worldOutlook);
      }

      switch (target) {
        case 'dramas':
          router.push('/drama');
          break;

        case 'props':
          router.push('/market');
          break;

        default:
          mode.value = target;
          break;
      }
    };

    const changeWorldOutlook = index => {
      mode.value = null;

      if (worldOutlook.value) {
        store.commit('update_world_outlook', null);
        return;
      }

      store.commit('update_world_outlook', woArray.value[index]);
    };

    const changeMode = () => {
      mode.value = null;
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (wo_item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "worldOutlook-item"
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(['world_outlook_basic_info', worldOutlook.value && worldOutlook.value.id === wo_item.id ? 'current_wo' : ''])
        }, [_createElementVNode("text", _hoisted_3, _toDisplayString(wo_item.name), 1), _createElementVNode("text", _hoisted_4, _toDisplayString(wo_item.nature) + " 世界观", 1)], 2), _createElementVNode("div", _hoisted_5, [_unref(isUserType)(userType.value) || _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          onClick: $event => changeWorldOutlook(index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(worldOutlook.value ? '切换世界观' : '选择为当前世界观'), 1)]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _withDirectives(_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modeArray.value, (item, index) => {
          return _openBlock(), _createBlock(WOItemCard, {
            key: index,
            title: item.title,
            desc: item.desc,
            image: item?.image,
            onClick: $event => handleClick(wo_item, item.key)
          }, null, 8, ["title", "desc", "image", "onClick"]);
        }), 128))], 512), [[_vShow, worldOutlook.value === null || mode.value === null]]), worldOutlook.value !== null && selectedModeData.value !== null ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("text", null, _toDisplayString(selectedModeData.value.title), 1), _createVNode(_unref(ElButton), {
          onClick: _cache[0] || (_cache[0] = $event => changeMode())
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 切换内容 ", -1)]))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_9, [mode.value === 'organizations' ? (_openBlock(), _createBlock(WOOrganizationList, {
          key: 0
        })) : mode.value === 'performances' ? (_openBlock(), _createBlock(WOPerformanceList, {
          key: 1
        })) : mode.value === 'entries' ? (_openBlock(), _createBlock(WOEntryExplanations, {
          key: 2
        })) : mode.value === 'apostles' ? (_openBlock(), _createBlock(WOApostleList, {
          key: 3
        })) : mode.value === 'ferryman' ? (_openBlock(), _createBlock(WOFerryman, {
          key: 4
        })) : mode.value === 'quarter' ? (_openBlock(), _createBlock(WOQuarterRank, {
          key: 5
        })) : mode.value === 'qualifications' ? (_openBlock(), _createBlock(WoQualifications, {
          key: 6
        })) : mode.value === 'marketChannels' ? (_openBlock(), _createBlock(WOMarketChannel, {
          key: 7
        })) : mode.value === 'marketProps' ? (_openBlock(), _createBlock(WOMarketProps, {
          key: 8
        })) : mode.value === 'roleProps' ? (_openBlock(), _createBlock(WORoleProps, {
          key: 9
        })) : mode.value === 'roles' ? (_openBlock(), _createBlock(WORoleList, {
          key: 10
        })) : mode.value === 'skills' ? (_openBlock(), _createBlock(WOSkills, {
          key: 11
        })) : mode.value === 'rolesWithOrganizations' ? (_openBlock(), _createBlock(WORolesWithOrganizations, {
          key: 12
        })) : mode.value === 'capabilityManager' ? (_openBlock(), _createBlock(WOCapabilityManager, {
          key: 13
        })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
      }), 128))])], 4);
    };
  }

};